import { attempt } from '@shared/utils'
import { logger } from '@shared/lib/logger'
import type { FulfillmentHistory, FulfillmentItem } from '@shared/types/fulfillment-history.types'

export interface FetchFulfillmentHistoryParams {
  api: string
  authorizationHeader: string
  shopperId: string
  orderNumber: string
}

export const getFulfillmentHistory = async ({
  api,
  authorizationHeader,
  shopperId,
  orderNumber,
}: FetchFulfillmentHistoryParams): Promise<Map<string, FulfillmentItem[]>> => {
  const url = `${api}/ui/shoppers/${shopperId}/orders/${orderNumber}/v2/fulfillmentHistory`
  const { data: response, error } = await attempt(
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: authorizationHeader,
      },
    }).then((res) => res.json() as Promise<FulfillmentHistory>),
  )

  if (error) {
    logger.error('Failed to fetch fulfillment history', {
      url,
      method: 'GET',
      errorMessage: error.message,
      action: 'fetch_fulfillment_history',
      requestStatus: 'failed',
    })
  }

  const itemsFulfillments = new Map<string, FulfillmentItem[]>()

  response?.lineItems?.forEach((item) => {
    if (item.fulfillments && item.fulfillments.length > 0) {
      itemsFulfillments.set(item.lineItemId, item.fulfillments)
    }
  })

  return itemsFulfillments
}
